import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AkitaFeaturedQuery } from '@app/akita/api/featured/state/featured.query';
import {} from '@app/akita/api/products/models/product-variant.model';

import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { StarFilledIconComponent } from '@app/shared/components/icons/generated/star-filled/star-filled.component';
import { StarHalfFilledIconComponent } from '@app/shared/components/icons/generated/star-half-filled/star-half-filled.component';
import { FeaturedReviewStatsModel } from '@app/shared/models/api/featured-review-stats.model';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Observable, of, Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-product-reviews-stats',
  templateUrl: './product-reviews-stats.template.html',
  styleUrls: ['./product-reviews-stats.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    CommonModule,
    TranslocoModule,
    StarFilledIconComponent,
    StarHalfFilledIconComponent,
  ],
})
export class ProductReviewsStatsComponent implements OnChanges, OnDestroy {
  @Input() public model?: string | null;

  public readonly biggerThan$: Observable<ScreenSizeInfoState>;
  public featuredReviewsStats$: Observable<FeaturedReviewStatsModel | null>;
  public phoneLanguage: string;
  public isAverageRatingPointFive = false;

  private readonly subscriptions: Subscription;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaFeaturedQuery: AkitaFeaturedQuery,
    private readonly translateService: TranslocoService
  ) {
    this.subscriptions = new Subscription();

    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();
    this.featuredReviewsStats$ = of(null);
    this.phoneLanguage = `${this.translateService.getActiveLang() || 'en'}`;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.model) {
      this.featuredReviewsStats$ = this.akitaFeaturedQuery
        .selectFeaturedReviewsStats(this.phoneLanguage, this.model)
        .pipe(
          tap((featuredReviewsStats: FeaturedReviewStatsModel | null) => {
            if (featuredReviewsStats?.averageRating) {
              this.isAverageRatingPointFive =
                // eslint-disable-next-line @typescript-eslint/no-magic-numbers
                featuredReviewsStats.averageRating % 1 >= 0.4;
            }
          })
        );
    }
  }

  public range(length: number | undefined): Array<number> {
    return Array(Math.floor(length || 0));
  }

  public trackByIndex(index: number): string {
    return `${index}`;
  }

  public ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
